import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { ApiGet, ApiPut } from "../../../service/ApiService";

const UserRoleModal = ({ show, onHide, user, refreshUsers, onRoleUpdate }) => {
    const [availableRoles, setAvailableRoles] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState("");

    // Fetch the fixed available roles once.
    useEffect(() => {
        ApiGet(
            "/api/user/role/available",
            (data) => {
                setAvailableRoles(data || []);
            },
            (err) => {
                setError(err.response?.data?.message || "Eroare la preluarea rolurilor disponibile.");
            }
        );
    }, []);

    // Fetch the roles assigned to the current user.
    useEffect(() => {
        if (user) {
            ApiGet(
                `/api/user/role/assigned/${user.id}`,
                (data) => {
                    setSelectedRoles(data || []);
                },
                (err) => {
                    setError(err.response?.data?.message || "Eroare la preluarea rolurilor atribuite.");
                }
            );
        } else {
            setSelectedRoles([]);
        }
    }, [user]);

    const toggleRole = (role) => {
        if (selectedRoles.includes(role)) {
            setSelectedRoles(selectedRoles.filter(r => r !== role));
        } else {
            setSelectedRoles([...selectedRoles, role]);
        }
    };

    const handleSave = () => {
        setError(null);
        ApiPut(
            `/api/user/role/assign/${user.id}`,
            { roles: selectedRoles },
            () => {
                setSuccess("Rolurile au fost actualizate cu succes.");
                if (onRoleUpdate) onRoleUpdate();
                refreshUsers();
                onHide();
            },
            (err) => {
                setError(err.response?.data?.message || "Eroare la actualizarea rolurilor.");
            }
        );
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Manage Roles for {user.email}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                {success && <Alert variant="success">{success}</Alert>}
                <Form>
                    {availableRoles.map((role) => (
                        <Form.Check
                            key={role}
                            type="checkbox"
                            label={role}
                            checked={selectedRoles.includes(role)}
                            onChange={() => toggleRole(role)}
                            className="mb-2"
                        />
                    ))}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Anulează
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    Salvează
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UserRoleModal;